/* global SentryDsn, SentryRelease, SentryEnvironment */
import { createInertiaApp, Link, Head } from '@inertiajs/vue3';
import { createApp, h } from 'vue';
import VueLazyload from 'vue-lazyload';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

// @todo: possibly add initialPage: JSON.parse(app.dataset.page),
export default createInertiaApp({
  resolve: (name) => import(`./Pages/${name}`).then((module) => module.default),
  setup({
    el, App, props, plugin,
  }) {
    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(VueLazyload, {
        error: `${window.location.origin}/img/image-placeholder.jpg`,
        loading: `${window.location.origin}/img/loading.gif`,
        attempt: 1,
        throttleWait: 2000,
      })
      .component('InertiaLink', Link)
      .component('InertiaHead', Head);
    Sentry.init({
      app,
      dsn: SentryDsn,
      release: SentryRelease,
      environment: SentryEnvironment,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.25,
      tracingOptions: {
        trackComponents: true,
      },
    });

    app.mount(el);
  },
  progress: {
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,

    // The color of the progress bar.
    color: '#29d',

    // Whether to include the default NProgress styles.
    includeCSS: true,

    // Whether the NProgress spinner will be shown.
    showSpinner: false,
  },
});
